import VisualizationChartType, { VisualizationChartTypeStrings } from 'enums/VisualizationChartType'
import WidgetType, { WidgetTypeStrings } from 'enums/WidgetType'
import { DashboardWidgetType } from 'features/dashboard/types'

const WIDGET_TYPE_TO_CHART_TYPE_MAP: Partial<
  Record<WidgetTypeStrings, VisualizationChartTypeStrings>
> = {
  [WidgetType.SOCIAL_WEB_TOPIC_COMPARISON]: VisualizationChartType.TOPIC_COMPARISON,
  [WidgetType.AUDIENCE_TOPIC_COMPARISON]: VisualizationChartType.TOPIC_COMPARISON,
  [WidgetType.SOCIAL_WEB_BRAND_PASSION_INDEX]: VisualizationChartType.BUBBLE_CHART
}

const convertWidgetTypeToChartType = (
  widgetSetting: DashboardWidgetType
): VisualizationChartTypeStrings => {
  if (!widgetSetting) {
    throw new Error('Widget setting is required')
  }
  if (!widgetSetting.type) {
    throw new Error('Widget setting must contain type property')
  }
  const chartType = WIDGET_TYPE_TO_CHART_TYPE_MAP[widgetSetting.type]
  if (chartType) {
    return chartType
  }
  throw new Error(
    `Widget type '${widgetSetting.type}' is not supported by the visualization service`
  )
}

export { convertWidgetTypeToChartType, WIDGET_TYPE_TO_CHART_TYPE_MAP }
